import React, { useEffect, useState, useRef } from "react";
import LogoImage from "../../images/AkaSoft.svg";
import { Link, useNavigate } from "react-router-dom";

const LandingNav = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [featureClick, setFeatureClick] = useState(false);
  const menuWrapperRef = useRef(null);

  /* SCROLL EFFECT */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* OUTSIDE CLICK CLOSE */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuWrapperRef.current &&
        !menuWrapperRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
        setFeatureClick(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <style>{`
        .ln-wrap {
          position: sticky;
          top: 0;
          height: 75px;
          background: white;
          display: flex;
          align-items: center;
          z-index: 1000;
        }

        .ln-wrap.scrolled {
          background: #fff0f4;
        }

        .ln-container {
          max-width: 1600px;
          width: 100%;
          margin: 0 auto;
          padding: 0 5rem;
        }

        .ln-inner {
          height: 75px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .ln-logo {
          width: 160px;
          cursor: pointer;
        }

        .ln-links {
          display: flex;
          gap: 32px;
        }

        .ln-link {
          font-weight: 500;
          color: #2c2c2c;
          cursor: pointer;
          text-decoration: none;
        }

        .ln-feature {
          position: relative;
        }

        .ln-dropdown {
          position: absolute;
          top: 120%;
          left: 0;
          min-width: 220px;
          background: #ffffff;
          border-radius: 10px;
          box-shadow: 0 12px 25px rgba(0,0,0,0.12);
          padding: 10px 0;
          z-index: 2000;
        }

        .ln-dropdown a {
          display: block;
          padding: 10px 18px;
          font-size: 14px;
          color: #2c2c2c;
          text-decoration: none;
        }

        .ln-btn {
          border-radius: 25px;
          border: none;
          padding: 8px 22px;
          height: 40px;
          font-weight: 600;
          background: #9E104C;
          color: #fff;
          cursor: pointer;
        }

        .ln-hamburger {
          display: none;
          font-size: 26px;
          cursor: pointer;
        }

        .ln-mobile-menu {
          position: fixed;
          top: 75px;
          left: 0;
          width: 100vw;
          background: white;
          padding: 20px;
          text-align: center;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          z-index: 999;
        }

        .ln-mobile-menu a {
          display: block;
          padding: 13px 0;
          font-size: 18px;
          color: #141414;
          text-decoration: none;
        }

        .ln-mobile-feature {
          font-size: 18px;
          padding: 13px 0;
          cursor: pointer;
        }

        @media (max-width: 992px) {
          .ln-links { display: none; }
          .ln-hamburger { display: block; }
          .ln-login-desktop { display: none; }
          .ln-container { padding: 0 2rem; }
        }
      `}</style>

      <div className={`ln-wrap ${scrolled ? "scrolled" : ""}`}>
        <div className="ln-container">
          <div className="ln-inner" ref={menuWrapperRef}>
            {/* LOGO */}
            <Link to="/">
              <img src={LogoImage} alt="Logo" className="ln-logo" />
            </Link>
            {/* <Link to="/" style={{textDecoration:"none", fontSize:"2.5rem"}}>
              <img src={LogoImage} alt="Logo" className="ln-logo" />
              <p className="m-0" style={{color:"#9d1c4d", fontWeight:"600"}}>AkaSoft</p>
            </Link> */}
            {/* DESKTOP LINKS */}
            <div className="ln-links">
              <Link to="/" className="ln-link">Home</Link>
               <div
                className="ln-feature"
                onClick={() => setFeatureClick((p) => !p)}
              >
                <span className="ln-link">Feature ▾</span>

                {featureClick && (
                  <div className="ln-dropdown">
                    <Link to="/whatsapp-campaign" onClick={() => setFeatureClick(false)}>WhatsApp Campaign</Link>
                    <Link to="/audiance-targating" onClick={() => setFeatureClick(false)}>Audiance Targating</Link>
                    <Link to="/personalized-message" onClick={() => setFeatureClick(false)}>Personalized Message</Link>
                    <Link to="/automated-replies" onClick={() => setFeatureClick(false)}>Automated Replies</Link>
                  </div>
                )}
              </div>
              <Link to="/about-us" className="ln-link">About</Link>
              <Link to="/pricing-page" className="ln-link">Pricing</Link>

             
            </div>

            {/* RIGHT */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                className="ln-btn ln-login-desktop"
                onClick={() => navigate("/login")}
              >
                Login
              </button>

              <div
                className="ln-hamburger"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                ☰
              </div>
            </div>

            {/* MOBILE MENU */}
            {menuOpen && (
              <div className="ln-mobile-menu">
                <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
                <Link to="/about-us" onClick={() => setMenuOpen(false)}>About</Link>
                <Link to="/pricing-page" onClick={() => setMenuOpen(false)}>Pricing</Link>

                <div
                  className="ln-mobile-feature"
                  onClick={() => setFeatureClick((p) => !p)}
                >
                  Feature ▾
                </div>

                {featureClick && (
                  <>
                    <Link to="/whatsapp-campaign" onClick={() => setMenuOpen(false)}>WhatsApp Campaign</Link>
                    <Link to="/audiance-targating" onClick={() => setMenuOpen(false)}>Audiance Targating</Link>
                    <Link to="/personalized-message" onClick={() => setMenuOpen(false)}>Personalized Message</Link>
                    <Link to="/automated-replies" onClick={() => setMenuOpen(false)}>Automated Replies</Link>
                  </>
                )}

                <button
                  className="ln-btn"
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/login");
                  }}
                >
                  Login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingNav;
